module.exports = __webpack_public_path__ + "static/media/left.c94f1d01.svg";